import apiClient from '../apiClient';
import { GET_INVOICES_BY_COMPANY_CODE_URL } from '../apiUrl';

const getInvoiceByCompanyCodeApi = Id => {
  return apiClient.get(GET_INVOICES_BY_COMPANY_CODE_URL(Id));
};

export default getInvoiceByCompanyCodeApi;
